/**
 * Common actions
 *
 */
export const CREATE_USER = 'CREATE_USER';
export const CHECK_TOKEN = 'CHECK_TOKEN';
export const GET_TOKEN = 'GET_TOKEN';
export const RECOVER_PASSWORD = 'RECOVER_PASSWORD';
export const SET_USER = 'SET_USER';
export const UPDATE_USER = 'UPDATE_USER';
export const GET_USER = 'GET_USER';
export const DO_LOGOUT = 'DO_LOGOUT';
